import * as WebFont from 'webfontloader';

WebFont.load({
  google: {
    families:  ['Nunito:100,200,300,400,600,700,800,900',
		'Poppins',
		'Bebas Neue',
		'Roboto Slab',
		'Sigmar',
		'Lora',
		"Bangers",
		"Knewave",
		'Font Color Emoji',
		'Bruno Ace',
		'Lobster',
		'Pacifico',
		'Short Stack',
		'Sedgwick Ave Display',
		'Libre Caslon Text',
		'Nunito',
		'Climate Crisis']
  }
});
